import React, { useState } from 'react';
import axios from 'axios';
import './TemplatesManagement.css';

const API = '/api/cms';

const CATEGORIES = [
  { value: 'general', label: 'Общие' },
  { value: 'status_change', label: 'Смена статуса' },
  { value: 'client_response', label: 'Ответ клиенту' },
  { value: 'internal', label: 'Внутренние' },
  { value: 'custom', label: 'Пользовательские' }
];

const TemplatesManagement = ({ templates, setTemplates, token, showMsg }) => {
  const [newTemplate, setNewTemplate] = useState({
    name: '',
    content: '',
    category: 'general',
    isPublic: false
  });
  const [editingId, setEditingId] = useState(null);
  const [editData, setEditData] = useState({});

  const h = { Authorization: `Bearer ${token}` };

  const createTemplate = async () => {
    if (!newTemplate.name.trim() || !newTemplate.content.trim()) {
      showMsg('⚠️ Заполните название и содержание');
      return;
    }
    try {
      const res = await axios.post(`${API}/templates`, newTemplate, { headers: h });
      setTemplates([...templates, res.data]);
      setNewTemplate({ name: '', content: '', category: 'general', isPublic: false });
      showMsg('✅ Шаблон создан');
    } catch (e) {
      showMsg(e.response?.data?.message || 'Ошибка создания шаблона');
    }
  };

  const startEdit = (template) => {
    setEditingId(template._id);
    setEditData({ name: template.name, content: template.content, category: template.category, isPublic: template.isPublic });
  };

  const saveEdit = async (id) => {
    try {
      const res = await axios.put(`${API}/templates/${id}`, editData, { headers: h });
      setTemplates(templates.map(t => t._id === id ? res.data : t));
      setEditingId(null);
      showMsg('✅ Шаблон обновлён');
    } catch (e) {
      showMsg(e.response?.data?.message || 'Ошибка обновления');
    }
  };

  const deleteTemplate = async (id) => {
    if (!window.confirm('Удалить шаблон?')) return;
    try {
      await axios.delete(`${API}/templates/${id}`, { headers: h });
      setTemplates(templates.filter(t => t._id !== id));
      showMsg('✅ Шаблон удалён');
    } catch (e) {
      showMsg('Ошибка удаления');
    }
  };

  const groupedTemplates = CATEGORIES.reduce((acc, cat) => {
    acc[cat.value] = templates.filter(t => t.category === cat.value);
    return acc;
  }, {});

  return (
    <div className="templates-management">
      <h2>📝 Шаблоны комментариев</h2>
      
      <div className="create-template-form">
        <h3>Создать шаблон</h3>
        <div className="form-group">
          <label>Название</label>
          <input 
            type="text" 
            value={newTemplate.name} 
            onChange={e => setNewTemplate({ ...newTemplate, name: e.target.value })} 
            placeholder="Например: Заявка принята в работу"
          />
        </div>
        <div className="form-group">
          <label>Содержание</label>
          <textarea 
            value={newTemplate.content} 
            onChange={e => setNewTemplate({ ...newTemplate, content: e.target.value })} 
            placeholder="Текст шаблона..."
            rows={3}
          />
        </div>
        <div className="form-row">
          <div className="form-group">
            <label>Категория</label>
            <select value={newTemplate.category} onChange={e => setNewTemplate({ ...newTemplate, category: e.target.value })}>
              {CATEGORIES.map(c => <option key={c.value} value={c.value}>{c.label}</option>)}
            </select>
          </div>
          <div className="form-group checkbox">
            <label>
              <input 
                type="checkbox" 
                checked={newTemplate.isPublic} 
                onChange={e => setNewTemplate({ ...newTemplate, isPublic: e.target.checked })} 
              />
              Публичный (виден всем)
            </label>
          </div>
        </div>
        <button className="btn btn-primary" onClick={createTemplate}>➕ Создать шаблон</button>
      </div>

      <div className="templates-list">
        <h3>Существующие шаблоны ({templates.length})</h3>
        
        {CATEGORIES.map(category => (
          groupedTemplates[category.value]?.length > 0 && (
            <div key={category.value} className="template-category">
              <h4>{category.label} ({groupedTemplates[category.value].length})</h4>
              <div className="templates-grid">
                {groupedTemplates[category.value].map(template => (
                  <div key={template._id} className="template-card">
                    {editingId === template._id ? (
                      <div className="template-edit">
                        <input 
                          type="text" 
                          value={editData.name} 
                          onChange={e => setEditData({ ...editData, name: e.target.value })}
                          placeholder="Название"
                        />
                        <textarea 
                          value={editData.content} 
                          onChange={e => setEditData({ ...editData, content: e.target.value })}
                          rows={3}
                        />
                        <select 
                          value={editData.category} 
                          onChange={e => setEditData({ ...editData, category: e.target.value })}
                        >
                          {CATEGORIES.map(c => <option key={c.value} value={c.value}>{c.label}</option>)}
                        </select>
                        <label className="checkbox-label">
                          <input 
                            type="checkbox" 
                            checked={editData.isPublic} 
                            onChange={e => setEditData({ ...editData, isPublic: e.target.checked })} 
                          />
                          Публичный
                        </label>
                        <div className="template-actions">
                          <button className="btn-sm" onClick={() => saveEdit(template._id)}>💾 Сохранить</button>
                          <button className="btn-sm" onClick={() => setEditingId(null)}>✕ Отмена</button>
                        </div>
                      </div>
                    ) : (
                      <>
                        <div className="template-header">
                          <h5>{template.name}</h5>
                          {template.isPublic && <span className="public-badge">🌐 Публичный</span>}
                        </div>
                        <p className="template-content">{template.content}</p>
                        <div className="template-footer">
                          <span className="usage-count">Использовано: {template.usageCount} раз</span>
                          <div className="template-actions">
                            <button className="btn-sm" onClick={() => startEdit(template)}>✏️</button>
                            <button className="btn-sm btn-danger" onClick={() => deleteTemplate(template._id)}>🗑️</button>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                ))}
              </div>
            </div>
          )
        ))}
        
        {templates.length === 0 && (
          <p className="empty-state">Нет шаблонов комментариев</p>
        )}
      </div>
    </div>
  );
};

export default TemplatesManagement;
